let language = {
    "A109B001": "店铺不存在",
    "A109B002": "店铺不存在",

    "A109B003": "您的合作伙伴账户尚未激活，请首先激活您的合作伙伴账户。",
    "A109B004": "您的合作伙伴账户尚未激活，请登录您的邮箱，查找注册邮件，然后激活您的合作伙伴账户。",

    "A109B005": "邮箱未激活",
    "A109B006": "邮箱未激活",
};

export { language }
